import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import DateRangeFilter from "components/DateRangeFilter";
import SelectCourseTitle from "components/SelectCourseTitle";
import { useIntl } from "react-intl";
import {
  CourseTitleModel,
  ListRequestOfBaseFilter,
  ListResponseOfCourseTitleModel,
} from "services/KnowfullyAdminClient";

type CourseTitleDateFilterProps = {
  cacheKey: string;
  fetchCourseTitles: (
    request: ListRequestOfBaseFilter,
  ) => Promise<ListResponseOfCourseTitleModel>;
  selectedCourseTitle: CourseTitleModel | null;
  onCourseTitleChange: (courseTitle: CourseTitleModel | null) => void;
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
  onDateFromChange: (date: Date | undefined) => void;
  onDateToChange: (date: Date | undefined) => void;
  dateRangeLabel: string;
};

const styles = {
  accordionDetails: {
    pb: 4,
  },
  courseTitleGrid: {
    display: "flex",
  },
  courseTitle: {
    flex: 1,
  },
};

const CourseTitleDateFilter = ({
  cacheKey,
  fetchCourseTitles,
  selectedCourseTitle,
  onCourseTitleChange,
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  dateRangeLabel,
}: CourseTitleDateFilterProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <Accordion sx={{ mb: 1 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{t({ id: "filtersLabel" })}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={styles.accordionDetails}>
        <Grid container spacing={2} alignItems="stretch">
          <Grid item xs={12} md={6} sx={styles.courseTitleGrid}>
            <SelectCourseTitle
              value={selectedCourseTitle}
              onChange={onCourseTitleChange}
              cacheKey={cacheKey}
              fetchCourseTitles={fetchCourseTitles}
              label={t({ id: "courseTitle" })}
              textFieldProps={{ variant: "outlined" }}
              sx={styles.courseTitle}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <DateRangeFilter
              fromLabel={`${dateRangeLabel} ${t({ id: "fromLabel" })}`}
              toLabel={`${dateRangeLabel} ${t({ id: "toLabel" })}`}
              fromValue={dateFrom}
              toValue={dateTo}
              onFromChange={onDateFromChange}
              onToChange={onDateToChange}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default CourseTitleDateFilter;
